export default __webpack_public_path__ + "assets/images/491b94f6343f8af863f955efb34c5c65.svg";